import React from 'react';
import {
  DataGridButton,
  DataGridButtonType,
  StylovyzeSearchBar,
  useGlobalization,
} from '@innovyze/stylovyze';
import { Button, Grid } from '@mui/material';

export interface CostTableListToolbarProps {
  onRefresh: () => void;
  searchValue: string;
  onSearch: (value: string) => void;
  onCreateClick: () => void;
  loading: boolean;
  hasEditAccess: boolean;
}

export const CostTableListToolbar: React.FC<CostTableListToolbarProps> = ({
  onRefresh,
  searchValue,
  onSearch,
  onCreateClick,
  loading,
  hasEditAccess,
}) => {
  const { t } = useGlobalization();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      style={{ padding: '8px 0', marginBottom: '8px' }}>
      <Grid item xs={4}>
        <StylovyzeSearchBar
          onChange={onSearch}
          onRequestSearch={() => onSearch(searchValue)}
          onCancelSearch={() => onSearch('')}
          placeholder={t('Search')}
          value={searchValue}
        />
      </Grid>
      <Grid
        item
        container
        xs={8}
        justifyContent="flex-end"
        alignItems="center"
        wrap="nowrap">
        <DataGridButton
          type={DataGridButtonType.REFRESH}
          disabled={loading}
          title={t('Refresh')}
          data-cy="cost-table-refresh"
          onClick={onRefresh}
          style={{ marginRight: '0.5rem' }}
        />
        {hasEditAccess && (
          <Button variant="contained" color="primary" onClick={onCreateClick}>
            {t('Create Cost Table')}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
